import React, { useContext } from 'react';
import { LocationsHero, StatesDropdownSection, SEO } from '../../components';
import { GlobalSiteDataContext } from '../../context';
import { graphql } from 'gatsby';
import './locations.css';

function LocationsPage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='locations-page'>
      <LocationsHero siteData={siteData} />
      <StatesDropdownSection siteData={siteData} />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.site.siteMetadata;
  return (
    <SEO
      location={location}
      origin={query.siteUrl}
      title={`${query.service} Locations | Find Your Nearest ${query.vertical}`}
      description=" As the nation's largest laser hair removal company, we have convenient locations all over. Click here to find a Milan laser hair removal near you."
    />
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        siteUrl
        umbrella
        vertical
        service
        title
      }
    }
  }
`;

export default LocationsPage;
